document.addEventListener("DOMContentLoaded", function () {
  const hotspots = document.querySelectorAll(
    ".hotspot-container[data-hotspot-x]",
  );

  function updateHotspotPositions() {
    const isMobile = window.innerWidth <= 749;

    hotspots.forEach((hotspot) => {
      if (isMobile) {
        const mobileX = hotspot.dataset.hotspotMobileX;
        const mobileY = hotspot.dataset.hotspotMobileY;

        hotspot.style.left = mobileX + "%";
        hotspot.style.top = mobileY + "%";
      } else {
        // Reset to desktop position
        const desktopX = hotspot.dataset.hotspotX;
        const desktopY = hotspot.dataset.hotspotY;

        hotspot.style.left = desktopX + "%";
        hotspot.style.top = desktopY + "%";
      }
    });
  }

  // Initial update
  updateHotspotPositions();

  // Update on window resize
  window.addEventListener("resize", updateHotspotPositions);
});
